import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=11225af2&scoped=true"
import script from "./customer_list.vue?vue&type=script&lang=ts"
export * from "./customer_list.vue?vue&type=script&lang=ts"
import style0 from "./customer_list.vue?vue&type=style&index=0&id=11225af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11225af2",
  null
  
)

export default component.exports